module.exports = __webpack_public_path__ + "static/10400556_21565747223_3524_n-6a9e360c4ac59d363da6a4ad6c874e0d.jpg";